module.exports = __webpack_public_path__ + "img/manage.d293a859.svg";